var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ml-base"},[_c('div',{staticClass:"font-bold mb-xs",class:{ 'cursor-pointer': !!_vm.$attrs.for }},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('div',{staticClass:"font-normal",class:{ 'cursor-pointer': !!_vm.$attrs.for }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }